import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BackdropModule } from '../../@fury/shared/backdrop/backdrop.module';
import { MaterialModule } from '../../@fury/shared/material-components.module';
import { LayoutComponent } from './layout.component';
import { FurySharedModule } from '../../@fury/fury-shared.module';
import { LoadingOverlayModule } from '../../@fury/shared/loading-overlay/loading-overlay.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FurySharedModule,

    // Core
    BackdropModule,
    LoadingOverlayModule,
    InfiniteScrollModule
  ],
  declarations: [LayoutComponent]
})
export class LayoutModule {
}
